import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2ac7a8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "custom-toggle__label custom-toggle__label-before"
}
const _hoisted_2 = ["checked", "disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-toggle__toggle" }, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "custom-toggle__label custom-toggle__label-after"
}

import { ref, watch } from 'vue';
  import { EToggleSize } from '../../common/enums/index.enum';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomToggle',
  props: {
    active: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    indeterminate: {
      default: false,
      type: Boolean,
    },
    labelAfter: {
      default: null,
      type: String,
    },
    labelBefore: {
      default: null,
      type: String,
    },
    size: {
      default: EToggleSize.MD,
      type: String as () => EToggleSize,
      validator: val => Object.values(EToggleSize).includes(val as EToggleSize),
    },
  },
  setup(__props) {

const props = __props;

  

  const customToggleInputCheckboxRef = ref<HTMLInputElement | null>(null);

  watch(() => props.indeterminate, () => {
    if(customToggleInputCheckboxRef.value) {
      customToggleInputCheckboxRef.value.indeterminate = props.indeterminate;
    }
  }, {
    immediate: true,
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["custom-toggle pointer", [
      `custom-toggle--${__props.size}`,
      { 'custom-toggle--disabled': __props.disabled },
    ]]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (!__props.disabled ? _ctx.$emit(`update:active`, !__props.active) : undefined))
  }, [
    (__props.labelBefore)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.labelBefore), 1))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      ref_key: "customToggleInputCheckboxRef",
      ref: customToggleInputCheckboxRef,
      checked: __props.active,
      disabled: __props.disabled,
      hidden: "",
      type: "checkbox"
    }, null, 8, _hoisted_2),
    _hoisted_3,
    (__props.labelAfter)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.labelAfter), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})